<template>
  <div class="create-account">
    <div class="container">
      <div class="flex justify-center">
        <div class="w-full max-w-lg mx-auto">
          <div class="card">
            <div class="p-12">
              <div class="mb-6">
                <h1 class="mb-2 text-2xl font-bold">Start Your Free Trial</h1>
                <p class="text-gray-500">No credit card required. Cancel any time.</p>
              </div>
              <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
                <div v-for="error in form_errors" :key="error.message">
                  {{ error.message }}
                </div>
              </div>
              <form @submit.prevent="register()" :disabled="submitting">
                <fieldset class="form-group">
                  <label for="name" class="form-label">Your Name</label>
                  <input id="name" placeholder="Enter your name" class="py-3 shadow-sm form-input" v-model="form.name" required autofocus tabindex="1">
                  <validations field="name" :errors="errors" />
                </fieldset>
                <fieldset class="form-group">
                  <label for="email" class="form-label">Email Address</label>
                  <input id="email" class="py-3 form-input" type="email" v-model="form.email" tabindex="2" placeholder="Enter your email address" required>
                  <validations field="email" :errors="errors" />
                </fieldset>
                <fieldset class="form-group">
                  <label for="password" class="items-center justify-between form-label">
                    Password 
                    <a class="text-xs font-medium tracking-wide uppercase text-primary hover:underline" href="#" @click="showPassword = !showPassword" tabindex="100">
                      {{ showPassword ? 'Hide' : 'Show' }} Password
                    </a>
                  </label>
                  <input id="password" class="py-3 form-input" :type="showPassword ? 'text' : 'password'" placeholder="Create a password" v-model="form.password" required tabindex="3">
                  <validations field="password" :errors="errors" />
                </fieldset>
                <fieldset class="form-group">
                  <label for="password_confirmation" class="form-label">
                    Confirm Password
                  </label>
                  <input type="password" placeholder="Confirm your new password" class="py-3 form-input" v-model="form.password_confirmation" required tabindex="4">
                  <validations field="password_confirmation" :errors="errors" />
                </fieldset>
                <button type="submit" class="w-full btn btn-lg btn-primary" v-submitting="submitting" tabindex="4">
                  Start Free Trial &rarr;
                </button>
                <div class="mt-6 text-center text-gray-500 form-text">
                  By signing up, you accept Fleetbeacon's <router-link :to="{ name: 'TermsOfService' }">Terms of Service</router-link> and <router-link :to="{ name: 'PrivacyPolicy' }">Privacy Policy</router-link>.
                </div>
              </form>
            </div>
          </div>
          <div class="my-8 text-center">
            Already have a Fleetbeacon account? <router-link :to="{ name: 'Login' }">Log in</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Register',

    metaInfo: {
      title: 'Register'
    },

    data () {
      return {
        submitting: false,
        showPassword: false,
        errors: [],
        form_errors: [],
        form: {
          name: '',
          email: '',
          password: '',
          password_confirmation: ''
        }
      }
    },

    methods: {
      async register () {
        try {
          this.submitting = true
          const { data } = await this.$api.post('auth/register', this.form)
          this.$cookies.remove('customer_token')
          this.$cookies.set('token', data.token.token)
          this.$router.push({ name: 'Onboarding' })
        } catch (error) {
          console.error(error)
          this.errors = error.response.data.messages.errors ? error.response.data.messages.errors : []
          this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
          this.$toasted.error(error.response.data.message)
        } finally {
          this.submitting = false
        }
      }
    }

  }
</script>